export const createStopListeningTool = (handler) => {
  return {
    type: 'function',
    name: 'stop',
    description:
      'If you believe you are done speaking you should call this function. If the user asks up to stop, call this function.',
    parameters: {
      type: 'object',
      strict: true,
      properties: {},
      required: [],
    },
    handler: handler,
  };
};

export const createActivateClinicModeTool = (handler) => {
  return {
    type: 'function',
    name: 'activate_clinic_mode',
    description:
      'Switch to Clinic Mode for quick command-based interactions. In clinic mode, the user says "Hey Comprehend" before each command and the assistant responds briefly then returns to listening for the wake word. Use this when the user wants to go back to quick commands, is done chatting, or wants efficient clinical workflow.',
    parameters: {
      type: 'object',
      strict: true,
      properties: {},
      required: [],
    },
    handler: () => handler('clinic'),
  };
};

export const createActivateConversationModeTool = (handler) => {
  return {
    type: 'function',
    name: 'activate_conversation_mode',
    description:
      'Switch to Conversation Mode for natural back-and-forth dialogue. In conversation mode, the user can continue speaking without repeating the wake word, allowing for a fluid conversation. Use this when the user wants to chat, have a discussion, ask follow-up questions, or requests conversation mode.',
    parameters: {
      type: 'object',
      strict: true,
      properties: {},
      required: [],
    },
    handler: () => handler('conversation'),
  };
};
